/**
 * NT-Robustez · Fase C — scrub PII and secrets before anything leaves the
 * process (Sentry events / breadcrumbs, API and web).
 *
 *   - Keys whose NAME looks sensitive (authorization, cookie, x-api-key,
 *     apikey, password, secret, token, key_hash, dsn, email…) → '[Filtered]'.
 *   - String VALUES are pattern-scrubbed anywhere (messages, URLs, stack
 *     frames' vars, breadcrumbs): JWTs, Bearer tokens, NeuraTrade keys
 *     (ntk_…), Supabase PATs (sbp_…), Anthropic / OpenAI keys, Sentry DSN
 *     secrets, `apikey=` / `key=` query params and e-mail addresses.
 * Pure, dependency-free, cycle-safe; returns a scrubbed deep copy.
 */
export const FILTERED = '[Filtered]';
const SENSITIVE_KEY = /^(authorization|proxy-authorization|cookie|set-cookie|x-api-key|apikey|api_key|password|passwd|secret|client_secret|token|access_token|refresh_token|id_token|key_hash|service_role_key|anon_key|dsn|email|e-mail)$/i;
const PATTERNS = [
    [/eyJ[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}/g, '[jwt]'],
    [/\bBearer\s+[A-Za-z0-9._~+/=-]+/gi, 'Bearer [Filtered]'],
    [/\bntk_[a-z]+_[A-Za-z0-9_]+/g, '[ntk_key]'],
    [/\bntk_[A-Za-z0-9]{16,}/g, '[ntk_key]'],
    [/\bsbp_[A-Za-z0-9]{20,}/g, '[sbp_token]'],
    [/\bsk-ant-[A-Za-z0-9_-]{10,}/g, '[anthropic_key]'],
    [/\bsk-(proj-)?[A-Za-z0-9_-]{20,}/g, '[openai_key]'],
    [/(https?:\/\/)[^:@\s/]+:[^@\s/]+@/g, '$1[Filtered]@'],
    [/([?&](?:apikey|api_key|key|token|access_token)=)[^&\s#]+/gi, `$1${FILTERED}`],
    [/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, '[email]'],
];
export function scrubText(s) {
    let out = s;
    for (const [re, rep] of PATTERNS)
        out = out.replace(re, rep);
    return out;
}
export function scrubSensitive(value, seen = new WeakMap()) {
    if (typeof value === 'string')
        return scrubText(value);
    if (value === null || typeof value !== 'object')
        return value;
    if (seen.has(value))
        return seen.get(value);
    if (Array.isArray(value)) {
        const arr = [];
        seen.set(value, arr);
        for (const v of value)
            arr.push(scrubSensitive(v, seen));
        return arr;
    }
    const out = {};
    seen.set(value, out);
    for (const [k, v] of Object.entries(value)) {
        out[k] = SENSITIVE_KEY.test(k) ? FILTERED : scrubSensitive(v, seen);
    }
    return out;
}
//# sourceMappingURL=scrub.js.map